import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFilter } from "../../store/slices/filterSlice";

const CertificateNumber = () => {
  const filterSelect = useSelector((state) => state?.filter);
  const dispatch = useDispatch();

  return (
    <div className="mt-3 d-flex gap-3 justify-content-center certificate-container">
      <div className="inner">
        <label className="filter-main-label text-start">
          Certificate Number
        </label>
        <input
          className="certificate-number-input"
          value={filterSelect?.certificateNumber}
          onChange={(e) =>
            dispatch(
              updateFilter({
                key: "certificateNumber",
                value: e.target.value,
              })
            )
          }
        />
      </div>
      <div className="inner">
        <label className="filter-main-label text-start">Stock Number</label>
        <input
          className="certificate-number-input"
          value={filterSelect?.stockNumber}
          onChange={(e) =>
            dispatch(
              updateFilter({
                key: "stockNumber",
                value: e.target.value,
              })
            )
          }
        />
      </div>
    </div>
  );
};

export default CertificateNumber;
